export default function () {
  const button = window.document.getElementById('c-skip-main');

  function firstInteractiveElement() {
    let el = null;
    const widget = document.querySelector('.bg-video__hero-filter-row.bg-video__hover ');

    if (widget) {
      const children = widget.querySelectorAll('.bg-video__hero-filter-col.bg-video__hover-target.bg-video__hover-target--col:not(.visually-hidden)');

      // eslint-disable-next-line array-callback-return,consistent-return
      Array.from(children).find((item) => {
        if (item.querySelector('[tabindex="0"]') !== null) {
          el = item.querySelector('[tabindex="0"]');
          return true;
        }
      });
    } else {
      const mcAll = window.document.querySelectorAll('main .c-custom-select, main a, main input, main select, main button:not(.c-skip-main), '
        + 'main textarea, footer a, footer input, footer select, footer button, footer textarea');

      mcAll.forEach((item) => {
        if (el !== null) {
          return false;
        }

        const tabindex = item.hasAttribute('tabindex') ? item.getAttribute('tabindex') : null;

        if (parseInt(tabindex, 10) === -1 || item.getAttribute('type') === 'hidden') {
          return false;
        }

        el = item;
        return true;
      });
    }

    return el;
  }

  function scrollToContent() {
    const mc = firstInteractiveElement();

    if (mc) {
      mc.focus();
    }
  }

  if (button) {
    button.addEventListener('keypress', (event) => {
      const keyCode = event.keyCode ? event.keyCode : event.which;

      if (keyCode === 13) {
        scrollToContent();
      }
    });
  }
}
